import { useEffect, useState } from "react";

import classNames from "classnames";

import { getCookie } from "@jti/fe-common";

import { ShopPageTeaser } from "./ShopPageTeaser";

import "./ShopLandingPage.scss";

export type ShopPageTeaserType = {
  title: string;
  path: string;
  backgroundImage: string;
  relatedLanguage: string;
};

type ShopLandingPageProps = {
  title: string;
  subtitle: string;
  shopPageTeasers: ShopPageTeaserType[];
  isInEditor?: boolean;
};

const rootClassName = "shopLandingPage";
const shopElementsSelector = ".productTeaserContainer__base, .shopFilter__base";

/**
 * Hide shop elements on the shop page if the language wasn't selected yet.
 */
export const hideShopElements = () => {
  const shopElements = document.querySelectorAll(shopElementsSelector);

  shopElements.forEach((element) => {
    element.classList.add(`${rootClassName}-sibling--hidden`);
  });
};

export const ShopLandingPage = ({ title, subtitle, shopPageTeasers, isInEditor }: ShopLandingPageProps) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isInEditor) {
      setIsVisible(true);
      return;
    }

    const currentLanguage = getCookie("language");
    if (!currentLanguage) {
      hideShopElements();
      setIsVisible(true);
    }
  }, [isInEditor]);

  return (
    <div
      className={classNames(rootClassName, {
        [`${rootClassName}--visible`]: isVisible,
      })}
      data-testid="shop-landing-page"
      aria-hidden={!isVisible}
    >
      <header className={`${rootClassName}__header`}>
        <h1 className={`${rootClassName}__title`}>{title}</h1>
        {subtitle && <h2 className={`${rootClassName}__subtitle`}>{subtitle}</h2>}
      </header>

      <nav>
        <ul className={`${rootClassName}__teasers-container`}>
          {shopPageTeasers?.map(({ title, path, backgroundImage, relatedLanguage }) => {
            return (
              <ShopPageTeaser
                key={title}
                title={title}
                path={path}
                backgroundImage={backgroundImage}
                relatedLanguage={relatedLanguage}
              />
            );
          })}
        </ul>
      </nav>
    </div>
  );
};
